import type { SampleItemList } from "@services/samples/list/type";
import { formatDateTime } from "@utils/formatters";
import {
  getTypeLabel,
  SAMPLE_TYPE_COLORS,
  type SampleType,
} from "@typings/entities/samples/enums";
import type { Sample } from "@typings/entities/samples";
import type { SamplesGeoJsonResponse } from "@services/samples/getGeoJson/type";

export interface SampleItemListWithLabels extends Omit<SampleItemList, "type"> {
  type: string;
}

export interface SampleWithLabels extends Omit<Sample, "type"> {
  type: string;
}

export function prepareSamplesTable(
  samples: SampleItemList[],
): SampleItemListWithLabels[] {
  return samples.map((sample) => ({
    ...sample,
    sampleDate: formatDateTime(sample.sampleDate || null),
    type: getTypeLabel(sample.type),
  }));
}

export function prepareSamplesView(sample: Sample): SampleWithLabels {
  return {
    ...sample,
    sampleDate: formatDateTime(sample.sampleDate || null),
    type: getTypeLabel(sample.type),
  };
}

export function mapColorToSamples(
  geoJson: SamplesGeoJsonResponse,
): SamplesGeoJsonResponse {
  return {
    ...geoJson,
    features: geoJson.features.map((feature) => ({
      ...feature,
      properties: {
        ...feature.properties,
        color: SAMPLE_TYPE_COLORS[feature.properties.type as SampleType].hex,
      },
    })),
  };
}
